export enum ROUTES {
  SIGN_IN = '/sign-in',
  RESOURCE_LIST = '/resource-list',
  RESOURCE_FORM = '/resource-form/:key',
}
